<app-page-body>
  <!-- header -->
  <app-page-header
    [title]="title"
    [isForm]="true"
    [loading]="loading"
    (onBack)="onClose()"
    (onRefresh)="onReset()"
  >
  </app-page-header>

  <!-- content -->
  <div class="app-page-content">
    <!-- form -->
    <form [formGroup]="form" autocomplete="off">
      <section>
        <fieldset>
          <legend>{{ pageVocabs + "legend" | translate }}</legend>
          <div class="row">
            <!-- mobile -->
            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
              <form-field
                [(value)]="model.mobile12"
                [control]="form?.get('number')"
                label="common.mobile"
                [maxLength]="12"
                [minLength]="10"
                type="tel"
                (change)="convertMobile()"
                [isMobileField]="true"
              >
              </form-field>
            </div>

            <!-- mobileOperator -->
            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
              <enum-select-search
                enumName="SmsAggregator"
                [label]="fields + 'mobileOperator'"
                [control]="form?.get('mobileOperator')"
                [(value)]="model.mobileOperator"
                (onError)="onClose()"
              >
              </enum-select-search>
            </div>

            <!-- simType -->
            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
              <enum-select-search
                enumName="SimType"
                [label]="fields + 'simType'"
                [control]="form?.get('simType')"
                [(value)]="model.simType"
                (onError)="onClose()"
              >
              </enum-select-search>
            </div>

            <!-- area -->
            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
              <zones-select-search
                class="tw-w-full"
                label="common.country"
                [control]="form?.get('areaId')"
                [id]="'null'"
                [value]="model.areaId"
                (valueChange)="onChangeZones($event, 'states')"
              >
              </zones-select-search>
            </div>

            <!-- state -->
            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
              <zones-select-search
                label="common.state"
                [control]="form?.get('stateId')"
                [id]="selectedCountry"
                [value]="model.stateId"
                (valueChange)="onChangeZones($event, 'cities')"
              >
              </zones-select-search>
            </div>

            <!--city(zoneId) -->
            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
              <zones-select-search
                class="tw-w-full"
                label="common.city"
                [control]="form?.get('cityId')"
                [id]="selectedState"
                [(value)]="model.cityId"
              >
              </zones-select-search>
            </div>

            <!-- zipCode -->
            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
              <form-field
                [(value)]="model.zipCode10"
                [control]="form?.get('zipCode')"
                label="common.zipCode"
                [maxLength]="10"
                [minLength]="10"
                type="tel"
              >
              </form-field>
            </div>

            <!-- guild -->
            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
              <business-group-select-search
                class="tw-w-full"
                [label]="fields + 'guildName'"
                [control]="form?.get('guildId')"
                (onError)="onClose()"
                [id]="'null'"
                [(value)]="model.guildId"
                (valueChange)="model.subGuildId = -1"
              >
              </business-group-select-search>
            </div>

            <!-- subGuild -->
            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
              <business-group-select-search
                class="tw-w-full"
                [label]="fields + 'subGuildName'"
                [control]="form?.get('subGuildId')"
                (onError)="onClose()"
                [fieldName]="'subGuild'"
                [id]="model.guildId"
                [(value)]="model.subGuildId"
                (valueChange)="model.subGuildId = $event"
              >
              </business-group-select-search>
            </div>
            <!--gender-->
            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
              <mat-button-toggle-group
                matInput
                [(ngModel)]="model.genderType"
                formControlName="genderType"
              >
                <span
                  class="tw-font-medium tw-self-center tw-px-[11px] tw-text-gray-700 dark:tw-text-gray-200"
                  >{{ "common.gender" | translate }}
                </span>
                <!-- male -->
                <mat-button-toggle [value]="GenderType.Man">
                  {{ "common.male" | translate }}
                  <mat-icon class="tw-mr-1 dark:tw-text-gray-300">man</mat-icon>
                </mat-button-toggle>
                <!-- female -->
                <mat-button-toggle [value]="GenderType.Woman">
                  {{ "common.female" | translate }}
                  <mat-icon class="tw-mr-1 dark:tw-text-gray-300"
                    >woman</mat-icon
                  >
                </mat-button-toggle>
                <!-- unknown -->
                <mat-button-toggle [value]="GenderType.All">
                  {{ "common.unknown" | translate }}
                </mat-button-toggle>
              </mat-button-toggle-group>
            </div>

            <div class="md:tw-w-1/2"></div>

            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4 tw-py-2">
              <mat-slide-toggle
                formControlName="isBlackList"
                [(ngModel)]="model.isBlackList"
              >
                {{ fields + "isBlackList" | translate }}
              </mat-slide-toggle>
            </div>

            <!-- sendToBlackList -->
            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4 tw-py-2">
              <mat-slide-toggle
                formControlName="isBlackListLocal"
                [(ngModel)]="model.isBlackListLocal"
              >
                {{ fields + "isBlackListLocal" | translate }}
              </mat-slide-toggle>
            </div>
          </div>
        </fieldset>
      </section>

      <!-- form btns-->
      <app-form-btns
        [loading]="loading"
        [form]="form"
        [isEdit]="formPageConfig.isEditMode"
        (onClose)="onClose()"
        (onSubmit)="onSubmit()"
      >
      </app-form-btns>
    </form>
  </div>
</app-page-body>
